<template>
  <div class="beast-login-warp validate" :class="{fixed: fixed}">
    <img v-if="showClose"  class="close" @click="close" src="./assets/close.png">
    <div class="login-head">
      <img src="./assets/wtf.png"></img>
      <p class="title" >为了你的账号安全，请验证手机</p>
    </div>
    <div class="login-main">
      <div class="input-warp">
        <div class="input-group" >
          <div>
            <div class="input-row" @click="selectCountry">
              <div class="phone-area">
                {{ country.country_code }}
              </div>
              <div class="phone-select">
                {{ country.country_name_cn }}
              </div>
            </div>
            <div class="input-row">
              <input type="text" v-model="mobile" placeholder="请输入手机号" @blur="blur" @focus="focus">
            </div>
            <div class="input-row" >
              <div class="phone-code">
                <input type="text" v-model="captchaCode" placeholder="请输入图形验证码" @blur="blur" @focus="focus">
              </div>
              <div class="phone-code-img" @click="changeCode">
                <img :src="captchaCodeSrc">
              </div>
            </div>
            <div class="input-row" >
              <div class="phone-code">
                <input type="text" v-model="mobileCode" placeholder="请输入短信验证码" @blur="blur" @focus="focus">
              </div>
              <div class="phone-code-text" @click="sendCode">
                {{ phone_code_text }}
              </div>
            </div>
            <div class="input-row" v-show="needPassword">
              <input type="password" v-model="password"   placeholder="设置密码" @blur="blur" @focus="focus">
              <i class="icon show-password"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rules">
      <div class="checkbox" :class="{ checked: checkRule }" @click="checkRule = !checkRule"></div>我已阅读并同意<a href="https://m.thebeastshop.com/eula">《野兽派服务条款》</a>和<a href="https://m.thebeastshop.com/rule">《隐私政策》</a>
    </div>
    <div class="login-tips">
      <span class="error">{{ error }}</span>
    </div>
    <div @click="validate" class="login-btn">
      完成登录
    </div>
    <merge :mergeShow="mergeShow" :phone="mobile" :mergeData="mergeData" @merge="merge" @cancel="mergeClose"></merge>
  </div>
</template>

<script>
import _country from './data/country.js'
import Vue from 'vue'
import Merge from './merge.vue'
import Select from '@/plugins/select'
import api from './api.js'
let _countDown = null
Vue.use(Select)
export default {
  components:  {
    Merge
  },
  data (){
   return {
    countryIndex: 0,
    error: '',
    mobile: '',
    codeEnd: 0,
    captchaCode: '',
    mobileCode: '',
    password: null,
    needPassword: false,
    codeTime: new Date().getTime(),
    mergeShow: false,
    mergeData: {},
    fixed: false,
    checkRule: false
   }
 },
 props: {
  showClose: {
    default: true
  }
 },
 computed: {
   country: function(){
     return _country[this.countryIndex]
   },
   phone_code_text: function(){
    return this.codeEnd === 0
      ? '获取验证码'
      : `重新获取(${this.codeEnd})`
   },
   captchaCodeSrc: function(){
    return `${process.env.AXIOS_BASE_URL}/app/captcha?_timestamp=${this.codeTime}`
   }
 },
 methods: {
  changeCode: function(){
    this.codeTime = new Date().getTime()
  },
  countDown: function(){
    if (this.codeEnd === 0) {
      clearTimeout(_countDown)
    }else{
      this.codeEnd--
      var that = this
      _countDown = setTimeout(function() {
        that.countDown()
      }, 1000)
    }
  },
  sendCode: function(){
    if(this.codeEnd > 0){
      return false
    }
    if(this.mobile.length!=11){
      this.$alert("请输入正确的手机号")
      return
    }
    if(this.captchaCode == ''){
      this.$alert("请输入图形验证码")
      return
    }
    if (!this.checkRule) {
      this.$alert('请先勾选同意《野兽派服务条款》和《隐私政策》')
      return
    }
    api.sms(this.mobile,this.captchaCode)
    .then((data) => {
      api.checkVerifiedMobile(this.mobile)
      .then(({code, data}) => {
        this.needPassword = data.needPassword
      })
      .catch((err) => {})
      this.codeEnd = 60
      this.countDown()
    })
    .catch(({code , message}) => {
      this.$alert(message)
    })
  },
  selectCountry: function(){
    this.$select(_country.map((item) => {
      return item.country_name_cn
    }))
    .then((data) => {
      this.countryIndex = data
    })
    .catch(()=>{})
  },
  close: function (){
    this.$emit('cancel')
  },
  merge: function(){
    this.$emit('verified')
  },
  mergeClose: function(){
    this.mergeShow = false
  },
  blur () {
    this.fixed = false
  },
  focus () {
    this.fixed = true
  },
  validate: function(){

    // this.mergeData = {"primary":{"id":"79160ee2-fc0d-42ae-a992-3d6d67d4c3d5","member":{"id":"M802060307","memberId":2060307,"createTime":1528169988000,"profile":{"nickName":"顺子","avatarUrl":"\"http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eoEGRPUt3jYaMRMAGbaSrxnXxPeCBHcbBVe4fdBDxpP6wq8TsDrysR7ILw1egOmrTnjKUGJ3KakWw/132\"","title":{"id":4,"name":"保密"},"birthday":null,"birthdayEditable":true,"birthdayBenefit":null},"mobileAreaCode":"+86","mobile":null,"level":{"id":-1,"name":"注册用户","avatarUrl":"http://img.thebeastshop.com/member/privilege/level-icon/level-zero.jpg"},"point":0.00,"loginMethods":[{"type":"WEIXIN_APP","principal":"ojX3VjsomvGkiYeVHH0reD_qzcdU","unionId":"oEI3GwB3UAtCsVA6qht_Dbfac3tM","mobileAreaCode":"+86"}]}},"subtle":{"id":"14aa3d67-dea9-4060-bb75-dbfb308508d4","member":{"id":"M802060306","memberId":2060306,"createTime":1528169453000,"profile":{"nickName":"顺子","avatarUrl":"\"http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eoEGRPUt3jYaMRMAGbaSrxnXxPeCBHcbBVe4fdBDxpP6wq8TsDrysR7ILw1egOmrTnjKUGJ3KakWw/132\"","title":{"id":4,"name":"保密"},"birthday":null,"birthdayEditable":true,"birthdayBenefit":null},"mobileAreaCode":"+86","mobile":"15618332825","level":{"id":-1,"name":"注册用户","avatarUrl":"http://img.thebeastshop.com/member/privilege/level-icon/level-zero.jpg"},"point":0.00,"loginMethods":[{"type":"MOBILE","principal":"15618332825","unionId":null,"mobileAreaCode":"+86"}]}},"attention":"合并账号将会把以上所列账号的会员积分、收货地址和订单等信息合并至本账号。请在合并账号前确定以上所列账号是否为自己的账号，合并流程不可逆。","mergeable":true}
    // this.mergeShow = true
    // return
    if (!this.checkRule) {
      this.$alert('请先勾选同意《野兽派服务条款》和《隐私政策》')
      return
    }
    if(this.mobile.length!=11){
      this.$alert("请输入正确的手机号")
      return
    }
    if(this.mobileCode == ''){
      this.$alert("请输入短信验证码")
      return
    }
    const password_reg = /^[a-z0-9]{6,16}$/i
    if(this.needPassword && !password_reg.test(this.password)){
      this.$alert("密码必须为6-16位数字或字母")
      return
    }
    api.verifiedMobile(this.mobile,this.mobileCode,this.password)
    .then(({ data }) => {
      if (data.primary.member.enroll) {
        try{
          TDH5SDK.account.register(data.primary.member.id)
        }catch(e){
          
        }
      }
      if(data.toast) {
        this.$toast(data.toast)
          .then(() => {
            if(data.subtle){
              this.mergeData = data
              this.mergeShow = true
            }else{
              this.$emit('verified')
            }
          })
      } else {
        if(data.subtle){
          this.mergeData = data
          this.mergeShow = true
        }else{
        
          this.$emit('verified')
        }
      }
      
    })
    .catch(({code , message}) => {
      this.$alert(message)
    })
  }
 }
}
</script>

<style lang="stylus">
  @import './index-old.styl'
</style>



// WEBPACK FOOTER //
// validate.vue?46a1296c